var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWindows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5937 0.33252L11.9844 2.33005V12.452L25.5937 12.3435V0.33252ZM0.334542 13.5503L0.335151 22.1636L10.6521 23.582L10.6439 13.6173L0.334542 13.5503ZM11.8761 13.6884L11.8952 23.736L25.5809 25.6675L25.5842 13.7109L11.8761 13.6884ZM0.327026 3.91971L0.336573 12.5288L10.6535 12.4701L10.6488 2.51368L0.327026 3.91971Z",
    fill: "#00ADEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindows);
export default __webpack_public_path__ + "static/media/windows.bc16681026b841308614786a013491cf.svg";
export { ForwardRef as ReactComponent };